<script>
  import PaperShowEvaluationResponses from './evaluation/Responses'
  import PaperShowEvaluationAppraisers from './evaluation/Appraisers'

  import helpers from '@mixins/helper'

  export default {
    components: {PaperShowEvaluationResponses, PaperShowEvaluationAppraisers},
    mixins: [helpers],
    name: 'paper-show-evaluation',
    props: ['paper'],
    data () {
      return {}
    },
    computed: {
      paperStatusKey: function () {
        return this.paper.status.key
      },
      isInvoiceOpened: function () {
        return this.paper.registration.status.key === 'em_aberto'
      },
      isInvoicePaid: function () {
        return this.paper.registration.status.key === 'pago'
      },
      isEditDaysAvailable: function () {
        return this.paper.event_paper_type.edit_limit_days > 0 &&
          this.momentInstance(this.paper.date_submitted)
            .add(this.paper.event_paper_type.edit_limit_days, 'days')
            .isBetween(
              this.momentNow(),
              this.momentNow().add(this.paper.event_paper_type.edit_limit_days, 'days')
            )
      },
      canBeEvaluated: function () {
        return this.paperStatusKey !== 'nao_designado' && this.paperStatusKey !== 'reprovado_pela_triagem'
      },
      canBeApproved: function () {
        return (this.isInvoicePaid && this.paper.event_paper_type.edit_limit_days === 0) || (!this.isEditDaysAvailable)
      }
    },
    methods: {
      reviews: function (eventPaperTypeEvaluationTypeId) {
        return this.paper.reviews.filter(item => item.event_paper_type_evaluation_type_id === eventPaperTypeEvaluationTypeId)
      }
    }
  }
</script>

<template>
    <div v-if="canBeEvaluated">
        <table class="table-confirmation table-evaluations"
               v-if="canBeApproved"
               v-for="evaluationType in paper.event_paper_type.evaluation_types">
            <thead>
            <tr>
                <th>
                    <span>{{evaluationType.evaluation_type.name}} /</span>
                    <span>De: {{evaluationType.start_datetime | dateTimeEnToBr}}</span>
                    <span>a {{evaluationType.end_datetime | dateTimeEnToBr}}</span>
                    <el-tag size="small" type="danger" v-if="evaluationType.evaluation_finished">
                        Finalizada
                    </el-tag>
                    <el-tag size="small" type="success" v-if="evaluationType.evaluation_opened">
                        Em andamento
                    </el-tag>
                    <el-tag size="small" type="info"
                            v-if="!evaluationType.evaluation_opened && !evaluationType.evaluation_finished">
                        Não disponível
                    </el-tag>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>
                    <paper-show-evaluation-responses v-if="paper"
                                                     :paper="paper"
                                                     :evaluation-type="evaluationType"
                                                     :reviews="reviews(evaluationType.id)"/>

                    <paper-show-evaluation-appraisers v-if="paper"
                                                      :paper="paper"
                                                      :evaluation-type="evaluationType"
                                                      :reviews="reviews(evaluationType.id)"/>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>



// WEBPACK FOOTER //
// Evaluation.vue?e8fd78f0